import { Box } from "@mui/material";
import { CalendarIcon } from "@radix-ui/react-icons";
import { fr } from "date-fns/locale/fr";
import { useEffect, useState } from "react";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { CRENEAUX, RENDEZ_VOUS } from "../../Utils/constant";
import rdv from "../../assets/images/rendez-vous.png";
import { find, store } from "../../services/service";
import { SubmitButton } from "../Widget/SubmitButton";
registerLocale("fr", fr);

export const PriseRendezVous = ({ numeroTicket, dateAuPlutard }) => {
  const [dateStartSurv, setStartDateSurv] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [creneau, setCreneau] = useState([]);
  const [loadCreneau, setLoadCreneau] = useState(true);
  const baseDate = dateAuPlutard ? new Date(dateAuPlutard) : new Date();
  const minSelectableDate = new Date(baseDate);
  minSelectableDate.setDate(minSelectableDate.getDate());

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    find(CRENEAUX)
      .then((result) => {
        setLoadCreneau(false);
        setCreneau(result?.data?.donnee);
      })
      .catch((err) => {});
  }, []);

  const submit = (data) => {
    setIsSubmit(true);
    const surveyRequest = {
      numeroTicket: numeroTicket,
      creneauId: data.creneauIdSurv,
      typeRdv: "SURVEY",
      dateRdv: dateStartSurv.toLocaleDateString().replace(/\//g, "-"),
    };
    store(RENDEZ_VOUS, "application/json", surveyRequest)
      .then((res) => {
        if (res.status === 200) {
          setIsSubmit(null);
          toast.success("Prise de rendez-vous éffectuée");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err?.response?.data?.donnee);
      });
  };

  return (
    <>
      {isSubmit !== null ? (
        <>
          <form
            onSubmit={handleSubmit(submit)}
            className="shadow-sm border rounded w-full p-8"
          >
            <div className="">
              <h1 class="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
                Rendez-vous Servey
              </h1>

              <div className="mx-auto">
                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
                  <label className="form-control flex flex-col  gap-2  w-full">
                    <label className="form-control  w-full">
                      <div className="label -mb-1 w-fit">
                        <span className="label-text ">
                          Date du rendez-vous{" "}
                          <span className="text-red-500">*</span>
                        </span>
                      </div>

                      <div className="px-2 flex items-center gap-2 border-[2px] w-full h-9 rounded-lg cursor-pointer">
                        <CalendarIcon className="" />
                        <ReactDatePicker
                          locale="fr"
                          dateFormat="dd-MM-yyyy"
                          minDate={minSelectableDate}
                          selected={dateStartSurv}
                          className="py-1 bg-transparent border-none focus:outline-none cursor-pointer text-sm"
                          onChange={(date) => {
                            setStartDateSurv(date);
                          }}
                          placeholderText="Choisir une date"
                        />
                      </div>
                    </label>
                    <div className="flex flex-row gap-2">
                      <label className="form-contro  w-full">
                        <div className="label -mb-1">
                          <span className="label-text">
                            Créneau horaire
                            <span className="text-red-500">*</span>
                          </span>
                        </div>

                        <select
                          {...register("creneauIdSurv", { required: true })}
                          className="select select-bordered w-full h-10"
                          disabled={loadCreneau}
                        >
                          <option value={""}>
                            {loadCreneau
                              ? "Chargement des creneau"
                              : "Choisir un Créneau"}
                          </option>
                          {creneau
                            ?.filter((e) => e?.isActif === true)
                            .map((item) => (
                              <option value={item.id}>
                                {item.heureDebut} - {item.heureFin}
                              </option>
                            ))}
                        </select>
                      </label>
                    </div>
                  </label>
                </div>
              </div>
              <SubmitButton isSubmit={isSubmit} label={"Enregistrer"} />
            </div>
          </form>
        </>
      ) : (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img className="mx-auto" src={rdv} height={80} width={80} alt="" />
            <p className="font-light mt-2  text-sm">
              Prise de rendez-vous effectuée
            </p>
          </div>
        </div>
      )}

      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <Link
            disabled={isSubmit !== null ? true : false}
            className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
            onClick={() => {
              window.history.back();
              localStorage.removeItem("numeroTicket");
            }}
          >
            Terminer
          </Link>
        </div>
      </div>
    </>
  );
};
